import * as React from 'react';
import { OrderInfoItem } from './OrderInfoItem';
import { OrderPackageVariant } from './OrderPackageVariant';
// import { format } from 'date-fns';
// import { pl } from 'date-fns/locale';

export interface OrderHeaderProps {
  createdAt: string;
  package_type: string;
  package_description: string;
  orderId: string;
}

export const OrderHeader: React.FC<OrderHeaderProps> = ({
  createdAt,
  package_type,
  package_description,
  orderId,
}) => {
  return (
    <div className="flex w-full justify-center bg-white">
      <section className="container flex flex-col items-center justify-center gap-2.5 py-[18px]">
        <div className="flex w-full flex-row items-center justify-center gap-6 max-md:gap-8 sm:gap-14">
          <OrderInfoItem label="Numer zamówienia" value={orderId} />
          <OrderInfoItem
            label="Data zamówienia"
            value={
              // format(new Date(createdAt), 'dd.MM.yyyy', { locale: pl }) ??
              createdAt
            }
          />
          <OrderPackageVariant
            description={package_description}
          />
        </div>
      </section>
    </div>
  );
};

export default OrderHeader;
